import { useContext, useEffect, useState } from "react";
import { getCoachTrainingSession } from "../../services/training-session";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import moment from 'moment';
import { t } from "i18next";
import trainingIcon from "../../assets/images/trainings.svg";
import { Link, useNavigate } from "react-router-dom";
import esLocale from '@fullcalendar/core/locales/es';
import { LoadingSpinner } from "../general/loading-spinner";
import { getCoachPlanning } from "../../services/planning";
import { UserContext } from "../../App";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export function CoachMiniCalendarBlock() {
    const navigate = useNavigate();

    const { userProfile } = useContext(UserContext);

    const [events, setEvents] = useState<any[]>([]);
    const [planning, setPlanning] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(true);

    // Función para eliminar sesiones duplicadas
    const getUniqueSessions = (sessions: any[]) => {
        const seen = new Set();
        return sessions.filter((session: any) => {
            const key = `${session.session}-${session.description}-${session.color}`;
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
    }

    const renderTooltip = (props: any) => {
        const event = props.event?._def?.extendedProps;

        return (
            <Tooltip id={`tooltip-${event?.team_id || 'unknown'}-${event?.day || 'unknown'}`} className="event-tooltip" {...props}>
                {event ? (
                    <>
                        <div style={{fontWeight: 'bold', marginBottom: '5px'}}>{event.team_name}</div>
                        { getUniqueSessions(event.sessions).map((session: any, index: number) => {
                            return <div key={`tooltip-session-${event.day}-${event.team_id}-${index}`} className="training-info-item">
                                <div className="description">
                                    <strong>S{session.session}: </strong>
                                    {session.description}
                                </div>
                            </div>;
                        })}
                    </>
                ) : (
                    <div>No data</div>
                )}
            </Tooltip>
        );
    }

    function eventContent(arg: any) {
        return (
            <OverlayTrigger placement="top" delay={{ show: 250, hide: 1000 }} overlay={renderTooltip(arg)}>
                <span className={ arg.event.classNames } style={{cursor: 'pointer'}}>
                    {arg.event.title}
                </span>
            </OverlayTrigger>);
    }

    useEffect(() => {
        getCoachPlanning(userProfile.id)
            .then(response => {
                console.log(response.data);
                setPlanning(response.data);

                // Transformar datos: crear un evento por cada día+equipo
                const calendarEvents: any[] = [];
                response.data.forEach((dayData: any) => {
                    dayData.teams.forEach((team: any) => {
                        const uniqueSessions = getUniqueSessions(team.sessions);
                        calendarEvents.push({
                            id: `${dayData.day}-${team.team_id}`,
                            title: `${team.team_name} (${uniqueSessions.length})`,
                            date: moment(dayData.day).format('YYYY-MM-DD'),
                            coach: userProfile.id,
                            day: dayData.day,
                            team_id: team.team_id,
                            team_name: team.team_name,
                            sessions: uniqueSessions,
                            color: uniqueSessions[0]?.color || '#34B689'
                        });
                    });
                });

                setEvents(calendarEvents);
                setLoaded(true);
            });
    }, []);

    /*const handleCalendarChange = (event: any) => {
        const start_time = moment(event.startStr).format('Y-MM-DD 00:00:00');
        const end_time = moment(event.endStr).format('Y-MM-DD 23:59:59');
        getCoachTrainingSession(start_time, end_time)
            .then(response => {
                setEvents(response.data.map((e: any) => {
                    return {
                        id: e.id.toString(),
                        title: e.name,
                        // classNames: ['training'], 
                        date: moment(e.date_time).format('YYYY-MM-DD'),
                        time: moment(e.date_time).format('HH-mm-ss'),
                        url: '/coach/training-sessions/' + e.id + '/phases',
                        color: e.color
                    }
                }));
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }*/

    return (
        <div className="block mini-calendar-container">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ trainingIcon } alt={ t("trainings")} />
                    { t("trainings") }
                </h3>
                <div className="block-content">
                    { !loaded && 
                        <LoadingSpinner />
                    }
                    { loaded &&
                        <FullCalendar
                            plugins={[ dayGridPlugin, bootstrap5Plugin ]}
                            initialView="dayGridMonth"
                            weekends={true}
                            firstDay={ 1 }
                            locale={esLocale}
                            height={ 'auto' }
                            events={ events }
                            eventContent= { eventContent }
                            // datesSet={ handleCalendarChange }
                        />
                    }
                    { loaded &&
                        <div className="events-list">
                            {
                                events.map((event: any, eventIndex: number) => {
                                    return getUniqueSessions(event.sessions).map((session: any, sessionIndex: number) => {
                                        return (
                                            <div key={ `event-${event.day}-${event.team_id}-${sessionIndex}` } className="event-item" style={{position: 'relative', paddingLeft: '30px'}}>
                                                <div className="color-mark" style={{backgroundColor: session.color}}></div>
                                                <div className="name">
                                                    <div style={{fontSize: '0.85em', color: '#888', fontWeight: 'bold'}}>{event.team_name}</div>
                                                    <strong>S{session.session}: </strong>
                                                    { session.description }
                                                </div>
                                                <div className="date">
                                                    { moment(event.day).format('D MMMM') }
                                                </div>
                                            </div>);
                                    });
                                })
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}  
